// frontend/src/pages/Category.js

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../utils/axiosConfig';
import { motion } from 'framer-motion';
import ArticleCard from '../components/UI/ArticleCard';

const Category = () => {
  const { slug } = useParams();
  const [articles, setArticles] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchCategoryArticles = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(`/articles/category/${slug}`);
      setArticles(res.data);
    } catch {
      setError('Fehler: Konnte Artikel für diese Kategorie nicht laden.');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCategoryArticles();
  }, [slug]);

  return (
    <motion.div
      className="py-8 container mx-auto px-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <h1 className="text-3xl md:text-4xl font-heading text-primary mb-6 capitalize break-words">
        {slug} - Artikel
      </h1>
      {error && <div className="bg-red-100 text-red-700 p-2 mb-4">{error}</div>}

      {loading ? (
        <div className="flex justify-center py-10">
          <div className="loader" />
        </div>
      ) : articles.length === 0 ? (
        <p className="text-gray-600">Keine Artikel in dieser Kategorie gefunden.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {articles.map((article) => (
            <ArticleCard key={article._id} article={article} />
          ))}
        </div>
      )}
    </motion.div>
  );
};

export default Category;
